import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';

import CommonTitle from '../../../common-components/common-title';
import CommonOlList from '../../../common-components/common-ol-list';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

let list = {
    colorNumber: '#a959e7',
    list: [
        'Разработать платформу',
        'Запустить систему личных кабинетов',
        'Реализовать игровую механику из техзадания',
        'Обеспечить бесперебойную работу ресурса в дни фестиваля',
    ],
};

const Process = () => {
    return (
        <div className="rukami-tasks">
            <FullWrapper isMargin={false}>
                <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
                    <div className="rukami-tasks__content">
                        <ScrollAnimation
                            animateIn="fadeInUp"
                            offset={100}
                            animateOnce={true}
                            duration={1}
                            className="upgreat-tasks__content"
                        >
                            <img
                                className="rukami-tasks__img"
                                src="/images/svg/rukami/rukami-tasks.svg"
                                alt=""
                                loading="lazy"
                            />
                            <div>
                                <CommonTitle>Задачи</CommonTitle>
                                <CommonOlList CommonOlList={list}></CommonOlList>
                            </div>
                        </ScrollAnimation>
                    </div>
                </ScrollAnimation>
            </FullWrapper>
        </div>
    );
};

export default Process;
